import React from 'react'
import PropTypes from 'prop-types'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import TextField from '@material-ui/core/TextField'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormLabel from '@material-ui/core/FormLabel'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import { isMobile } from '../../../../utils'

import { styles } from '../../styles'
import { RadioWrapper } from './styles'

export const BinForm = ({
  me,
  handleSubmit,
  touched,
  errors,
  handleChange,
  values,
  handleBlur,
  handleUpload,
  setFieldValue,
  saveHeroImage
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <Card elevation={isMobile ? 0 : 1} style={styles.card}>
        <div style={styles.avatarWrapper}>
          <input
            style={styles.input}
            accept="image/*"
            id="avatar-button-file"
            onChange={(e) => handleUpload({ e, saveHeroImage, heroId: me.id })}
            type="file"
          />
          <label htmlFor="avatar-button-file">
            <Avatar style={styles.avatar} src={me.imageUrl}>
              {me.name && (
                <Typography variant="h3" color="inherit">
                  {me.name.substring(0, 1)}
                </Typography>
              )}
            </Avatar>
          </label>
        </div>
        <CardContent style={{ textAlign: 'center' }}>
          <FormControl
            margin="normal"
            fullWidth
            error={touched.name && Boolean(errors.name)}>
            <TextField
              id="inputName"
              type="text"
              name="name"
              label="ชื่อถัง"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.name && Boolean(errors.name)}
            />
            {touched.name && errors.name && (
              <FormHelperText>{errors.name}</FormHelperText>
            )}
          </FormControl>

          <FormControl
            margin="normal"
            fullWidth
            error={touched.address && Boolean(errors.address)}>
            <TextField
              id="inputAddress"
              type="text"
              name="address"
              label="ที่อยู่"
              value={values.address}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.address && Boolean(errors.address)}
            />
            {touched.address && errors.address && (
              <FormHelperText>{errors.address}</FormHelperText>
            )}
          </FormControl>

          <FormControl
            margin="normal"
            fullWidth
            error={touched.desc && Boolean(errors.desc)}>
            <TextField
              id="inputDesc"
              type="text"
              name="desc"
              label="คำอธิบายสถานที่ตั้ง"
              multiline
              rows="3"
              value={values.desc}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.desc && Boolean(errors.desc)}
            />
            {touched.desc && errors.desc && (
              <FormHelperText>{errors.desc}</FormHelperText>
            )}
          </FormControl>

          <FormControl component="fieldset" margin="normal" fullWidth>
            <FormLabel component="label" style={{ textAlign: 'left' }}>
              ถังนี้เปิดให้บุคคลทั่วไปทิ้งหรือไม่
            </FormLabel>
            <RadioWrapper>
              <RadioGroup
                row
                name="isPublic"
                value={values.isPublic}
                onChange={() => setFieldValue('isPublic', !values.isPublic)}>
                <FormControlLabel
                  control={<Radio checked={values.isPublic} />}
                  label="ใช่"
                />
                <FormControlLabel
                  control={<Radio checked={!values.isPublic} />}
                  label="ไม่ใช่ (ไม่สามารถมองเห็นในแผนที่)"
                />
              </RadioGroup>
            </RadioWrapper>
          </FormControl>

          <FormControl component="fieldset" margin="normal" fullWidth>
            <FormLabel component="label" style={{ textAlign: 'left' }}>
              ถังนี้รับเฉพาะขยะที่ไม่ต้องแยก (ทิ้งแบบเร็ว)
            </FormLabel>
            <RadioWrapper>
              <RadioGroup
                row
                name="isQuick"
                value={values.isQuick}
                onChange={() => setFieldValue('isQuick', !values.isQuick)}>
                <FormControlLabel
                  control={<Radio checked={values.isQuick} />}
                  label="ใช่"
                />
                <FormControlLabel
                  control={<Radio checked={!values.isQuick} />}
                  label="ไม่ใช่"
                />
              </RadioGroup>
            </RadioWrapper>
          </FormControl>

          <FormControl component="fieldset" margin="normal" fullWidth>
            <FormLabel component="label" style={{ textAlign: 'left' }}>
              ถังนี้มีอุปกรณ์ช่วยในการแยกหรือไม่ เช่น มีด กรรไกร คีม ไขควง
              ล้างน้ำ
            </FormLabel>
            <RadioWrapper>
              <RadioGroup
                row
                name="hasTool"
                value={values.hasTool}
                onChange={() => setFieldValue('hasTool', !values.hasTool)}>
                <FormControlLabel
                  control={<Radio checked={values.hasTool} />}
                  label="ใช่"
                />
                <FormControlLabel
                  control={<Radio checked={!values.hasTool} />}
                  label="ไม่มี (แยกด้วยมือเปล่า)"
                />
              </RadioGroup>
            </RadioWrapper>
          </FormControl>
        </CardContent>
      </Card>
    </form>
  )
}

BinForm.propTypes = {
  me: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  handleUpload: PropTypes.func.isRequired,
  saveHeroImage: PropTypes.func.isRequired
}

export default BinForm



// WEBPACK FOOTER //
// ./src/pages/Profile/components/BinForm/index.js